module.exports = __webpack_public_path__ + "static/img/java.edbe6fa5.png";